export const SET_IS_ONLINE = 'misc/SET_IS_ONLINE';
export const SET_MEASURED_PIPE = 'misc/SET_MEASURED_PIPE';

export default {}; // eslint no likey no default
